export default class Numbers {
  static MAX_FILE_SIZE_MB_HUMAN = 20;

  static MAX_FILE_SIZE = 1024 * 1024 * Numbers.MAX_FILE_SIZE_MB_HUMAN;
}
